import type { DSData } from 'webapp-types';

import DsDataOutputBase from 'webapp/models-custom/ds-data/output/base';
import DsDataPointCompare from 'webapp/models-custom/ds-data/point/compare';
import type DsDataRootCompare from 'webapp/models-custom/ds-data/root/compare';

export default class DsDataOutputCompare extends DsDataOutputBase {
	dataRoot: DsDataRootCompare;
	points: DsDataPointCompare[];

	constructor(dataRoot: DsDataRootCompare, rawData: DSData.PointGroupCompare) {
		super(rawData);
		this.dataRoot = dataRoot;
		this.points = (rawData.items || []).map(
			(pointData) => new DsDataPointCompare(this, pointData),
		);
	}

	// used when we know this is a number
	get point(): DsDataPointCompare | null {
		return this.points[0] || null;
	}

	get compareSettings() {
		return this.dataRoot.compareSettings;
	}

	override getPointForIndex(index: number) {
		return super.getPointForIndex(index) as DsDataPointCompare | null;
	}
}
